import { Http } from "../../utils/types";
import { ObjectGeneric } from "../../utils/types/generals";
import { ListItemResponse, ResponseAllDropDownList, ResponseCrudDropList, ResponseDropDownList } from "./response";

export const dropDownListService = (client: Http) => ({
    getDropList: async ({ query }: { query?: string }): Promise<ResponseDropDownList> => await client.get(`drop-downs/dashboard${query ? '?' + query : ''}`),
    deleteList: async (id: number): Promise<ResponseCrudDropList> => await client.delete(`drop-downs/${id}`),
    createList: async (body: ObjectGeneric): Promise<ResponseCrudDropList> => await client.post('drop-downs', body),
    getListById: async ({id}:{id:number}): Promise<ListItemResponse> => await client.get(`drop-downs/detail/${id}`),
    editList: async ({id, body}:{id:number, body: ObjectGeneric}): Promise<ResponseCrudDropList> => await client.put(`drop-downs/${id}`, body),
    getAllDropList: async (): Promise<ResponseAllDropDownList> => await client.get('drop-downs/all'),
})